export default "__VITE_ASSET__C7hmyk4o__"